import { FC } from "react";
import { Segmented } from "antd";
import { useTranslation } from "react-i18next";

const DECK_LABEL_KEYS: Record<number, string> = {
  0: "Flights.details.ssr.mainDeck",
  1: "Flights.details.ssr.upperDeck",
};

const DeckSelection: FC<{
  decks: number[];
  value: number;
  onChange: (deck: number) => void;
}> = ({ decks, value, onChange }) => {
  const { t } = useTranslation();

  if (decks.length <= 1) return null;

  return (
    <div className="flex w-full justify-center py-2">
      <Segmented
        options={decks.map((deck) => ({ value: deck, label: t(DECK_LABEL_KEYS[deck]) }))}
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

export default DeckSelection;
